var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "_scroll-indicator" }, [
    _c("img", { attrs: { src: _vm.src } }),
    _c("div", { staticClass: "content" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }